import { PaymentDetailsHeader } from "./payment-details-header";
import { PaymentDetailsPreviewProps } from "./types";
import { BigNumber } from "bignumber.js";
import { calculateFeesForPreview } from "./lib/calculate-fees";
import { formatPrice } from "./lib/format-price";
import { FeeBreakdown } from "./fee-breakdown";
import { SummaryLine } from "./summary-line";

export const InvestmentAmountPaymentDetailsPreview = ({
	title,
	investmentId,
	updatedAt,
	createdAt,
	currency = "USD",
	feeView = "simplified",
	investmentAmount = "0",
	className,
	feeDetails = [],
	gstPercentage = "0",
}: PaymentDetailsPreviewProps) => {
	const investmentAmountBN = BigNumber(investmentAmount);
	const gstPercentageBN = BigNumber(gstPercentage);
	
	const result = calculateFeesForPreview(
		investmentAmountBN,
		feeDetails,
		gstPercentageBN.toNumber(),
	);
	const totalFee = result.fee.toNumber();
	const gstFee = result.gstFee.toNumber();
	const totalFeeWithGst = result.totalFeeWithGst.toNumber();

	return (
		<div className={`rounded-lg border p-4 pt-0 w-[600px] ${className}`}>
			<div className="flex flex-col gap-4">
				<PaymentDetailsHeader
					title={title}
					updatedAt={updatedAt}
					investmentId={investmentId}
					createdAt={createdAt}
				/>
				<SummaryLine
					field="Investment amount"
					value={`${formatPrice(investmentAmountBN.toNumber())} ${currency.toUpperCase()}`}
				/>
				<FeeBreakdown
					totalFees={BigNumber(totalFee)}
					gstFee={BigNumber(gstFee)}
					feeView={feeView}
					gstPercentage={gstPercentageBN.toNumber()}
					currency={currency}
					feeDetails={feeDetails}
				/>
				<hr />
				<div className="flex justify-between">
					<div className="text-sm font-bold text-gray-600">Total</div>
					<div className="text-sm font-bold text-[#383838]">{`${formatPrice(
						totalFeeWithGst,
					)} ${currency.toUpperCase()}`}</div>
				</div>
			</div>
		</div>
	);
};
